import {
  GET_WORKORDERS,
  GET_WORKORDERS_SUCCESS,
  GET_WORKORDERS_FAIL,
  ADD_WORKORDER,
  ADD_WORKORDER_SUCCESS,
  ADD_WORKORDER_FAIL,
  UPDATE_WORKORDER,
  UPDATE_WORKORDER_SUCCESS,
  UPDATE_WORKORDER_FAIL,
  DELETE_WORKORDER,
  DELETE_WORKORDER_SUCCESS,
  DELETE_WORKORDER_FAIL,
  SET_WORKORDER_FIELD_ERRORS,
  GET_WORK_ORDER_STATES,
  GET_WORK_ORDER_STATES_SUCCESS,
  GET_WORK_ORDER_STATES_FAIL,
} from './actionTypes'

// Get Workorders
export const getWorkOrders = (userId, status, startDate, endDate, teamId, solutionId, createdAt, sebelUserId, displayLength, displayStart, sortCol, sortDir, search) => ({
  type: GET_WORKORDERS,
  payload: { status, startDate, endDate, teamId, userId, solutionId, createdAt, sebelUserId, displayLength, displayStart, sortCol, sortDir, search }
})

export const getWorkOrdersSuccess = (workorders) => ({
  type: GET_WORKORDERS_SUCCESS,
  payload: workorders,
})

export const getWorkOrdersFail = (error) => ({
  type: GET_WORKORDERS_FAIL,
  payload: error,
})

// Add Workorder
export const addWorkOrder = (workorder, navigate) => ({
  type: ADD_WORKORDER,
  payload: { workorder, navigate },
})

export const addWorkOrderSuccess = (workorder) => ({
  type: ADD_WORKORDER_SUCCESS,
  payload: workorder,
})

export const addWorkOrderFail = (error) => ({
  type: ADD_WORKORDER_FAIL,
  payload: error,
})

// Update Workorder
export const updateWorkOrder = (workorder) => ({
  type: UPDATE_WORKORDER,
  payload: workorder,
})

export const updateWorkOrderSuccess = (workorder) => ({
  type: UPDATE_WORKORDER_SUCCESS,
  payload: workorder,
})

export const updateWorkOrderFail = (error) => ({
  type: UPDATE_WORKORDER_FAIL,
  payload: error,
})

// Delete Workorder
export const deleteWorkOrder = (id) => ({
  type: DELETE_WORKORDER,
  payload: id,
})

export const deleteWorkOrderSuccess = (id) => ({
  type: DELETE_WORKORDER_SUCCESS,
  payload: id,
})

export const deleteWorkOrderFail = (error) => ({
  type: DELETE_WORKORDER_FAIL,
  payload: error,
})

// Set Field Errors
export const setWorkOrderFieldErrors = (errors) => ({
  type: SET_WORKORDER_FIELD_ERRORS,
  payload: errors,
})

// Get Work Order States
export const getWorkOrderStates = () => ({
  type: GET_WORK_ORDER_STATES,
})

export const getWorkOrderStatesSuccess = (states) => ({
  type: GET_WORK_ORDER_STATES_SUCCESS,
  payload: states,
})

export const getWorkOrderStatesFail = (error) => ({
  type: GET_WORK_ORDER_STATES_FAIL,
  payload: error,
})
